const PRESETS = [
  { label: "Sharp", values: [0, 0, 0, 0] },
  { label: "Soft", values: [12, 12, 12, 12] },
  { label: "Pill", values: [50, 50, 50, 50] },
  { label: "Circle", values: [50, 50, 50, 50], unit: "%" },
  { label: "Squircle", values: [30, 30, 30, 30] },
  { label: "Leaf", values: [80, 8, 80, 8] },
  { label: "Scallop", values: [50, 0, 50, 0] },
];

export default PRESETS;
